import { LightSplashPanelSignIn } from './LightSplashPanelSignIn';

export const SplashPanelSignIn = () => {
  /* TODO: Rename the light theme and make it the main one */
  return <LightSplashPanelSignIn />;
};
